@if (area().isApplicable && locationAction() === LocationActionEnum.Viewing) {
  <a [attr.id]="'area-' + area().id"
     class="area-card"
     [class.newly-added]="isNewlyAdded()"
     [href]="getAreaUrl(area().id)"
     (click)="onClickAssertions(area(), $event)"
     data-testid="job-areas-card-area">
    <div class="card-left-wrapper">
      <div class="card-space-left">
        @if (area().completed) {
          <img class="area-status--completed"
               src="assets/icons/check.svg"
               alt="Completed" />
        }
      </div>
      <div class="card-left">
        <div class="area-name">{{ area().name }}</div>
        <div class="area-status">
          @if (!area().started) {
            Not started
          } @else {
            {{ area().completedAssertions }} / {{ area().assertions.length }}
            @if (area().hasIssues) {
              | {{ area().issues.length }} Attention items
            }
          }
        </div>
      </div>
    </div>
    <div class="card-right">
      <i class="pi pi-chevron-right"></i>
    </div>
  </a>
}
@else if (locationAction() !== LocationActionEnum.Viewing) {
  <div class="na-selection-card"
       data-testid="job-areas-card-mark-na">
    <div class="na-card-left">
      <div class="area-name">{{ area().name }}</div>
    </div>
    <div class="na-card-right"
         (click)="toggleNaStatus(area().id!)">
      <div class="area-actions">
        <div class="na-radio-input-container">
          <p-radiobutton [disabled]="true"
                         binary
                         styleClass="mark-na"
                         name="mark-na-radio-button"
                         [value]="isMarkedNa"
                         [(ngModel)]="isMarkedNa"
                         [inputId]="'mark-na-area-' + area().id" />
          <label [for]="'mark-na-area-' + area().id"
                 class="mark-na-label ml-2">
            {{
              locationAction() === LocationActionEnum.MarkAsNA
                ? "Mark as N/A"
                : "Remove N/A"
            }}
          </label>
        </div>
      </div>
    </div>
  </div>
}